export default __webpack_public_path__ + "static/media/phones.144fc4a3.jpg";